document.addEventListener('DOMContentLoaded', function () {
    var sleep = 2500;
    var productGridContainer = document.querySelector('.product-grid-container');
    var loadMoreButton = document.getElementById('loadMoreButton');

    function showElements(count) {
        var elementsToShow = document.querySelectorAll('.scroll-infinite.d-none');
        for (var i = 0; i < Math.min(count, elementsToShow.length); i++) {
            elementsToShow[i].classList.remove('d-none');
        }
    }

    function handleEvent() {
        setTimeout(() => {
            showElements(show_first);
            hideLoadButtonIfNoMoreElements();
        }, sleep);
    }

    function countElements() {
        var elementsCount = document.querySelectorAll('.product-grid-container .scroll-infinite').length;
        document.querySelector("#ProductCountDesktop").innerHTML = elementsCount + " products";
    }

    function hideLoadButtonIfNoMoreElements() {
        if (document.querySelectorAll('.scroll-infinite.d-none').length === 0) {
            loadMoreButton.style.display = 'none';
        }
    }

    loadMoreButton.addEventListener('click', function () {
        showElements(show_first);
        hideLoadButtonIfNoMoreElements();
    });

    var observer = new MutationObserver(function (mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
                handleEvent();
                hideLoadButtonIfNoMoreElements();
            }
        }
    });

    var observerConfig = { childList: true, subtree: true };
    observer.observe(productGridContainer, observerConfig);

    function initializeScript() {
        observer.disconnect();

        var eventElements = [
            { selector: 'input[type="checkbox"]', event: 'click' },
            { selector: '#SortBy', event: 'change' },
            { selector: '.active-facets__button-remove', event: 'click' },
            { selector: 'a', event: 'click' }
        ];

        eventElements.forEach(function (element) {
            var elements = document.querySelectorAll(element.selector);
            elements.forEach(function (item) {
                item.addEventListener(element.event, handleEvent);
            });
        });

        showElements(show_first);
        hideLoadButtonIfNoMoreElements();

        observer.observe(productGridContainer, observerConfig);
        
        countElements();
    }

    initializeScript();
});
